namespace PaperTrail.Web.Modules.NewsletterControl.Newsletter {
    export interface PublishNewsletterRequest extends Serenity.ServiceRequest {
        NewsletterEntity?: NewsletterControl.NewsletterRow;
        NewsletterID?: number;
        IsPreview?: boolean;
    }
}
